import http from './api'
import { Menu, CreateMenuData, GenerateMenuData } from '../types/menu'

class MenuService {
  async getMenus(restaurantId: string): Promise<Menu[]> {
    const response = await http.get(`/menus?restaurantId=${restaurantId}`)
    return response.data
  }

  async getMenu(id: string): Promise<Menu> {
    const response = await http.get(`/menus/${id}`)
    return response.data
  }

  async createMenu(data: CreateMenuData): Promise<Menu> {
    const response = await http.post('/menus', data)
    return response.data
  }

  async updateMenu(id: string, data: Partial<CreateMenuData>): Promise<Menu> {
    const response = await http.patch(`/menus/${id}`, data)
    return response.data
  }

  async deleteMenu(id: string): Promise<void> {
    await http.delete(`/menus/${id}`)
  }

  async generateMenu(data: GenerateMenuData): Promise<Menu> {
    const response = await http.post('/menus/generate', data)
    return response.data
  }
}

const menuService = new MenuService()
export default menuService
